export enum LEVELS {
  EASY = "easy",
  MEDIUM = "medium",
  HARD = "hard",
  EXPERT = "expert",
  EXTREME = "extreme",
}
